import { OwnerFragment } from 'graphql/bindings/AdminBindings'
import pick from 'lodash/pick'

export interface Owner {
  owner_id?: number
  name?: string
}

const filterOwnersByGroupAndStripIds = (owners: OwnerFragment[], group: string) => {
  return owners
    .filter(owner => owner.owner_group === group)
    .map(owner => pick<Owner>(owner, 'owner_id', 'name') as Owner)
}

export { filterOwnersByGroupAndStripIds }
